import { render, staticRenderFns } from "./information-page.component.vue?vue&type=template&id=946abd6a&"
import script from "./information-page.component.vue?vue&type=script&lang=ts&"
export * from "./information-page.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports